<template>
  <basic-container>
    <div class="relending-collection-detail">
      <div class="inner-con">
        <div class="project-title">
          {{ basicInfoData.collectTitle ? basicInfoData.collectTitle : "" }}
        </div>
        <!-- <div class="project-status" v-if="basicInfoData.auditStatus != 2">
          <div class="status-title">审批状态</div>
          <div class="status-content" :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]">
              {{basicInfoData.auditStatusStr}}
          </div>
        </div> -->
        <div class="project-status">
          <div class="status-one" v-if="basicInfoData.flagBookkeepingStr">
            <div class="status-title">记账状态</div>
            <div
              class="status-content"
              :class="['stateTopdiv', 'color_' + basicInfoData.flagBookkeeping]"
            >
              {{ basicInfoData.flagBookkeepingStr }}
            </div>
          </div>
          <div class="status-one" v-if="basicInfoData.flagVerifiedStr">
            <div class="status-title">核销状态</div>
            <div
              class="status-content"
              :class="['stateTopdiv', 'color_' + basicInfoData.flagVerified]"
            >
              {{ basicInfoData.flagVerifiedStr }}
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="详情信息" name="first">
            <InfoContainer
              style="margin-top: 20px"
              :infoTitle="projectConfig['infoTitle']"
              :contentConfig="projectConfig['infoContent']"
            >
              <template #basicInfo>
                <CommonDetail
                  :configArray="detailFormConfig"
                  :initValue="basicInfoData"
                >
                </CommonDetail>
              </template>

              <template #projectInfo>
                <CommonDetail
                  :configArray="projectFormConifg"
                  :initValue="basicInfoData"
                >
                </CommonDetail>
              </template>
            </InfoContainer>

            <!-- 流程公共附件 -->
            <Accessory
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="uploadPermissionNameOne && uploadPermissionNameTwo"
              :idname="uploadPermissionNameTwo"
              :fileMenuUrlname="uploadPermissionNameOne"
              :projectid="basicInfoData.projectId"
              :dynamicId="id"
              :upload="true"
              :permissionList="permissionList"
              :isPermission="true"
            /> 
            <!-- 流程设计审批信息表单 -->
            <AuditInfo
              ref="auditInfo"
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="
                isStartedProcess &&
                auditFormData &&
                auditFormData != {} &&
                auditFormData.allAppForm
              "
              :formDetailData="auditFormData"
              :isEditable="
                processDetail.process ? processDetail.process.isEditable : false
              "
              :status="
                processDetail.process && processDetail.process.status
                  ? processDetail.process.status
                  : 'done'
              "
            />

            

            <!-- 会签意见区 -->
            <CommentStep
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="commentList.length > 0"
              :commentList="commentList"
              :taskSaveData="taskSaveData"
              :taskNo="
                processDetail.process ? Number(processDetail.process.taskNo) : 0
              "
              :status="
                processDetail.process && processDetail.process.status
                  ? processDetail.process.status
                  : 'done'
              "
            />
            <!-- 流程记录  -->
            <CommentTable
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="flowData.length > 0"
              :flowData="flowData"
            />

            <!-- 会签意见区 -->
            <InfoContainer
              v-if="!isStartedProcess"
              class="comment-container"
              style="margin-top: 20px"
              :infoTitle="commentBlockConfig['infoTitle']"
              :contentConfig="commentBlockConfig['infoContent']"
            >
              <template #comment>
                <CommentBlock
                  ref="commentBlock"
                  @fileChange="fileChange"
                  :id="id"
                />
              </template>
            </InfoContainer>
          </el-tab-pane>

          <!-- 流程图（启动流程后显示） -->
          <el-tab-pane label="流程跟踪" name="fourth" v-if="isStartedProcess">
            <template v-if="activeName == 'fourth'">
              <el-card shadow="never" style="margin-top: 5px">
                <wf-design
                  ref="bpmn"
                  style="height: 500px"
                  :options="bpmnOption"
                ></wf-design>
              </el-card>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <BottomLine
      ref="bottomLine"
      startProcessName="提交核销"
      :auditState="basicInfoData.flagVerified"
      :processDetail="processDetail"
      :isStartedProcess="isStartedProcess || basicInfoData.flagVerified == 2"
      :goEdit="
        (!isStartedProcess &&
        basicInfoData.flagVerified != 2 &&
        basicInfoData.auditState == 0)||(workFlowState.isFirstFlowPermission&&isStartedProcess)"
      
      @goEdit="goEdit"
      @buildNewOne="buildNewOne"
      @startProcess="saveProject(true)"
      @saveTask="saveTask"
      @saveProject="saveProject"
      @flowNext="flowNext"
      @openPrintForm="goPrint"
      @refreshData="refreshData"
    />

    <Verification ref="verif" @verificheckreturn="verificheckreturn" />
  </basic-container>
</template>

<script>
import * as api from "@/api/zd/collection";
import InfoContainer from "@/components/infoContainer/infoContainer";
import CommonDetail from "@/components/commonDetail/commonDetail";

// 工作流相关组件
import Accessory from "@/components/accessoriesother/accessoryFactor";
import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo";
import CommonSelect from "@/components/commonSelect/commonSelect";
import CommentStep from "@/components/workflowComponents/commentStep/commentStep";
import CommentTable from "@/components/workflowComponents/commentTable/commentTable";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
import { mapGetters } from "vuex";
import Verification from "./components/verificationVisible";
export default {
  name: "bankmanageDetail",
  mixins: [workFlow, util],
  data() {
    return {
      activeName: "first",
      detailFormUrl: "/zd/collectionmanage/collectionDetail",
      processKey: "process_zd_collect",
      basicInfoData: {
         projectId:''
      },
      projectConfig: {
        infoTitle: "项目信息",
        infoContent: [
          {
            title: "基本信息",
            prop: "basicInfo",
          },
          {
            title: "财务信息",
            prop: "projectInfo",
          },
        ],
      },
      detailFormConfig: [
        {
          label: "投放名称",
          prop: "collectTitle",
          span: 8,
        },
        {
          label: "款项类型",
          prop: "collectionTypeStr",
          span: 8,
        },
        {
          label: "客户名称",
          prop: "contract",
          propInner: "custName",
          span: 8,
        },
        {
          label: "项目名称",
          prop: "contract",
          propInner: "projectName",
          span: 8,
        },
        {
          label: "合同名称",
          prop: "contract",
          propInner: "contractName",
          span: 8,
        },
        {
          label: "核算主体",
          prop: "accountingEntityStr",
          span: 8,
        },
        {
          label: "客户经理",
          prop: "contract",
          propInner: "managerName",
          span: 8,
        },
        {
          label: "申请部门",
          prop: "contract",
          propInner: "deptName",
          span: 8,
        },
        {
          label: "实际收款日期",
          prop: "actualCollectDate",
          span: 8,
        },
        // {
        //   label: "对应放款批次",
        //   prop: "loanLot",
        //   span: 8,
        //   formatter: (label, value) => {
        //     return value;
        //   },
        // },
      ],
      projectFormConifg: [
        {
          label: "收款金额",
          prop: "collectionAmount",
          span: 8,
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "大写金额",
          prop: "collectionAmountStr",
          span: 8,
        },

        {
          label: "付款人开户行",
          prop: "payOpeningBank",
          span: 8,
        },
        {
          label: "付款人户名",
          prop: "payAccountName",
          span: 8,
        },
        {
          label: "付款人账号",
          prop: "payBankAccount",
          span: 8,
        },
        {
          label: "收款人开户行",
          prop: "collectOpeningBank",
          span: 8,
        },
        {
          label: "收款人户名",
          prop: "collectBankAccount",
          span: 8,
        },
        {
          label: "收款人账号",
          prop: "collectAccountName",
          span: 8,
        },
      ],
    };
  },
  components: {
    InfoContainer,
    CommonDetail,
    Accessory,
    AuditInfo,
    CommentStep,
    CommentTable,
    BottomLine,
    CommonSelect,
    CommentBlock,
    Verification,
  },

  watch: {
    $route: {
      handler() {
        let id = this.$route.params.id;
        this.onLoad(id);
      },
      deep: true,
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.onLoad(this.id);
  },
  computed: {
    ...mapGetters(["permission", "userInfo", "workFlowState"]),
  },
  methods: {
    //提交核销
    updatastate() {
      let that = this;
      this.$confirm("是否确定提交核销?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api
            .submitFlagVerified({ id: that.basicInfoData.id })
            .then((res) => {
              that.$message({
                type: "success",
                message: res.data.msg,
              });
              that.onLoad(that.data.id);
            })
            .catch((res) => {});
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 核销
    verification() {
      this.$refs.verif.showblockdetail(this.basicInfoData);
    },
    //核销回传
    verificheckreturn(data) {
      api
        .changeFlagVerified({
          id: data.id,
          flagVerified: 2,
          verificationTime: data.verificationTime,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.onLoad(this.$route.params.id);
        })
        .catch((res) => {});
    },
    refreshData() {
      this.onLoad(this.id);
    },

    goEdit() {
      this.$router.push({
        path: `/zd/collectionmanage/edit/${this.id}`,
      });
    },

    async onLoad(id) {
      api
        .collectioninfo({ id: id })
        .then(async (res) => {
          let dataList = [
            { code: "collection_type", name: "collectionType" },
            { code: "accounting_entity", name: "accountingEntity" },
            { code: "flag_verified", name: "flagVerified" },
            { code: "flag_bookkeeping", name: "flagBookkeeping" },
          ];

          let dataSource = await this.dictionaryMap(dataList, res.data.data);
          this.$nextTick(() => {
            this.basicInfoData = dataSource;
          });

          // 查询当前流程任务数据
          this.queryFlowTaskDetail(
            res.data.data.flowableId ? res.data.data.flowableId : "",
            dataSource.flagVerified
          );
        })
        .catch((res) => {});
    },

    // 保存尽调数据
    async saveTask() {
      await this.workFlowSaveTask();
      // 刷新数据
      this.saveTask = {
        comment: "",
        attachment: [],
      };
      this.onLoad(this.id);
      this.$forceUpdate();
    },

    // 流程流转
    async flowNext(taskInfoList) {
      let processInsId = this.processDetail.process.processInstanceId;
      let taskId = this.processDetail.process.taskId;
      let taskName = this.processDetail.process.taskName;
      let valid = false;
      // 流程表单数据
      if (
        this.$refs.auditInfo.avueFormConfig.column &&
        this.$refs.auditInfo.avueFormConfig.column.length > 0
      ) {
        valid = this.$refs.auditInfo.validData();
      } else {
        valid = true;
      }
      if (valid) {
        let customData = this.$refs.auditInfo.commentDetail;
        let formData = this.$refs.auditInfo.$data.formData;

        let variables = this.dealAuditForm(formData, customData);

        if (taskInfoList) {
          await this.selectPeopleFlowNext(
            taskId,
            taskName,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            variables,
            JSON.stringify(taskInfoList)
          );
        } else {
          await this.taskFlowNext(
            taskId,
            processInsId,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            variables
          );
        }
        // 刷新数据
        this.onLoad(this.id);
        this.$forceUpdate();
      }
    },

    async saveProject(startProcess) {
      let params = {
        ...this.basicInfoData,
        id: this.basicInfoData.id == -1 ? undefined : this.basicInfoData.id,
      };

      if (startProcess) {
        let redirectInfo = {
          url: this.detailFormUrl,
          id: this.id,
        };

        // let processNameRes = await getPocessName(params)
        let processParams = {
          detailFormUrl: JSON.stringify(redirectInfo),
          processId: this.processDefinedId,
          comment: this.$refs.commentBlock.$data.opinionContent,
          attachmentList: this.attchmentList,
          processInstanceName: `${this.basicInfoData.collectTitle}转贷收款流程`,
        };
        let processInsId = await this.startWorkFlowProcess(processParams);
        params.flowableId = processInsId;
      }
      this.btnSave(params);
    },

    btnSave(params) {
      let self = this;
      // api
      //   .submitTips({
      //     projectPlacementId: this.basicInfoData.projectPlacementId,
      //     id: this.$route.params.id,
      //   })
      //   .then((res) => {
      //     let tbpname = "";
      //     let index = 0;
      //     if (
      //       res.data.data.isOrgin == 1 ||
      //       res.data.data.isOutUsage == 1 ||
      //       res.data.data.isUsage == 1
      //     ) {
      //       if (res.data.data.isOrgin == 1) {
      //         tbpname += "本金";
      //         index = 1;
      //       }
      //       if (res.data.data.isOutUsage == 1) {
      //         if (index == 1) {
      //           tbpname += "、";
      //         }
      //         tbpname += "超期手续费";
      //         index = 1;
      //       }
      //       if (res.data.data.isUsage == 1) {
      //         if (index == 1) {
      //           tbpname += "、";
      //         }
      //         tbpname += "手续费";
      //         index = 1;
      //       }
      //       this.opens(tbpname, params);
      //     } else {
      api
        .collectionsubmit(params)
        .then((res) => {
          self.onLoad(self.id);
        })
        .catch((res) => {});
      //   }
      // });
    },

    opens(names, data) {
      let self = this;
      const h = this.$createElement;
      this.$msgbox({
        title: "注意",
        message: h("p", null, [
          h("span", null, '该项目已存在 "'),
          h("span", { style: "color: #F56C6C" }, names),
          h("span", null, '" 的收款申请！是否继续操作？ '),
        ]),
        showCancelButton: true,
        confirmButtonText: "继续保存",
        cancelButtonText: "再看看吧",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            api
              .collectionsubmit(data)
              .then((res) => {
                done();
                instance.confirmButtonLoading = false;
                self.onLoad(self.id);
                // this.$router.push({
                //   path: `/zd/collectionmanage/collectionDetail/${res.data.data}`,
                // });
              })
              .catch((res) => {});
          } else {
            done();
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.relending-collection-detail {
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;
  .inner-con {
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;
    .project-name {
      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
    }
    .project-name:hover {
      color: #409eff;
      cursor: pointer;
    }
    .project-title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }
    .project-status {
      display: flex;
      justify-content: flex-end;
      .status-one {
        margin-left: 12px;
        .status-title {
          text-align: right;
          font-family: "微软雅黑", sans-serif;
          font-weight: 400;
          color: #999999;
          font-size: 14px;
        }
        .status-content {
          text-align: right;
          font-family: "微软雅黑", sans-serif;
          font-weight: 400;
          color: #666666;
          font-size: 20px;
        }
      }
    }
  }

  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
    margin-bottom: 2px;
  }
  .color_0::before {
    background: #fec03d;
  }
  .color_1::before {
    background: #409eff;
  }
  .color_2::before {
    background: #51d351;
  }
  .color_3::before {
    background: #f56c6c;
  }
  .color_4::before {
    background: #f56c6c;
  }
  .banktail_ .el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 10px;
  }
  /deep/.el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 10px;
  }
  /deep/.el-tabs__item.is-active {
    background: none;
  }
  /deep/.el-tabs__header {
    margin: 0px;
  }
}
.bottom-container {
  width: 100%;
  height: 70px;
  position: fixed;
  // z-index: 1000;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);
  .button-container {
    width: 78%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
